<!--
 * @Author: gaozexiong RJgaozexiong@ruijie.com.cn
 * @Date: 2022-07-26 10:50:49
 * @LastEditors: gaozexiong RJgaozexiong@ruijie.com.cn
 * @LastEditTime: 2022-08-26 16:23:43
 * @FilePath: \ces-vue-serve\src\views\Finance\fundManagement.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1">
        <span slot="label">待审核认款错误</span>
        <payment-error-audit />
      </rj-tab-pane>
      <rj-tab-pane name="2">
        <span slot="label">已审核认款错误</span>
        <readyPaymentError />
      </rj-tab-pane>
      <rj-tab-pane name="3">
        <span slot="label">待审核认款错误（退换货）</span>
        <paymentErrorAuditThh />
      </rj-tab-pane>
      <rj-tab-pane name="4">
        <span slot="label">已审核认款错误（退换货）</span>
        <readyPaymentErrorThh />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import paymentErrorAudit from './components/paymentErrorAudit.vue';
import paymentErrorAuditThh from './components/paymentErrorAuditThh.vue';
import readyPaymentError from './components/readyPaymentError.vue';
import readyPaymentErrorThh from './components/readyPaymentErrorThh.vue';
export default {
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    paymentErrorAudit,
    paymentErrorAuditThh,
    readyPaymentError,
    readyPaymentErrorThh
  },
  data () {
    return {
      tabsActive: '1'
    };
  },
  computed: {},
  mounted () {},
  methods: {}
};
</script>

<style>

</style>
